import { initializeApp } from 'firebase/app';
import { getMessaging } from 'firebase/messaging';
import { firebaseConfig } from './config';

const app = initializeApp(firebaseConfig);
export const messaging = getMessaging(app);
export default app;